var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "successTitle"
  }, "Success") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "successTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#01BFA5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,1.6 C6.2562386,1.6 1.6,6.2562386 1.6,12 C1.6,17.7437614 6.2562386,22.4 12,22.4 C17.7437614,22.4 22.4,17.7437614 22.4,12 C22.4,6.2562386 17.7437614,1.6 12,1.6 Z M16.5201312,8.99216488 C16.8300063,9.2573284 16.8873006,9.708028 16.6683434,10.039833 L16.6078351,10.1201312 L11.8158541,15.7201312 C11.5236978,16.0615506 11.0143758,16.091398 10.6846779,15.8052377 L10.611963,15.733589 L8.203944,13.0436647 C7.90925093,12.7144721 7.93721834,12.2087128 8.26641096,11.9140197 C8.57028112,11.6419953 9.02459856,11.6449006 9.3244796,11.9058761 L9.396056,11.9764866 L11.1944,13.9848 L15.3921649,9.0798688 C15.6794254,8.74417072 16.184433,8.70490432 16.5201312,8.99216488 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.33d72973d53a086fa742d3c94e0b032a.svg";
export { ForwardRef as ReactComponent };